var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.26,177.05c-0.74-2.09-2.15-2.98-3.25-4.08C106.66,122.58,56.29,72.21,5.91,21.86C3.07,19.02,0.7,16.08,0.8,11.76 c0.1-4.41,1.92-7.8,5.79-9.87c3.95-2.11,8-1.96,11.78,0.49c1.52,0.99,2.82,2.35,4.12,3.64c50.22,50.19,100.43,100.4,150.61,150.63 c1.12,1.12,1.9,2.59,3.12,4.27c1.46-2.3,1.09-3.69,1.09-4.97c0.02-36.76,0.01-73.53,0.03-110.29c0-7.56,4.8-12.31,11.96-12.01 c5.63,0.23,10.19,4.69,10.54,10.35c0.07,1.14,0.04,2.3,0.04,3.45c0,46.3-0.14,92.6,0.13,138.9c0.05,8.53-5.41,13.43-13.21,13.38 c-46.87-0.26-93.75-0.12-140.62-0.14c-7.72,0-12.62-4.91-12.24-12.13c0.29-5.52,4.61-9.96,10.12-10.36 c1.37-0.1,2.76-0.05,4.13-0.05c35.85,0,71.69,0,107.54,0C157.09,177.05,158.46,177.05,160.26,177.05z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDown);
export default __webpack_public_path__ + "static/media/RightDown.2bf3530ba83732bcaf99fd2792c4714e.svg";
export { ForwardRef as ReactComponent };